import { Stack, Typography } from "@mui/material";
import ActionButton from "@quest_editor/components/Buttons/ActionButton";
import BackButton from "@quest_editor/components/Buttons/BackButton";
import DangerButton from "@quest_editor/components/Buttons/DangerButton";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import Breadcrumb from "@quest_editor/components/Breadcrumb";
import PromotionTypeChip from "@quest_editor/components/Chips/PromotionTypeChip";
import PromotionStatusChip from "@quest_editor/components/Chips/PromotionStatusChip";
import { useQuest, usePromotion } from "@quest_editor/mocks";
import { getPromotionLabels } from "@quest_editor/utils/view/promotionLabels";
import { getBuildOptionsDisplay } from "@quest_editor/utils/view/buildOptionsDisplay";
import OrderInfoSection from "./OrderInfoSection";
import PlaceholderSection from "./PlaceholderSection";

const QuestOrderReview = () => {
  const { t } = useTranslation("questEditor");
  const { id: questId } = useParams<{ id: string }>();

  const { data: questData } = useQuest(questId);
  const quest = questData?.quest;

  const { data: promotionData } = usePromotion(quest?.promotionId);
  const promotion = promotionData?.promotion;

  const { getTypeLabel } = getPromotionLabels();
  const { buildOptionsDisplay } = getBuildOptionsDisplay();

  if (!quest || !promotion) {
    return <Typography>{t("common.label.not_found")}</Typography>;
  }

  return (
    <Stack direction="column" spacing={3} sx={{ flex: 1, minHeight: 0 }}>
      <Stack direction="column" spacing={2} alignItems="flex-start">
        <Breadcrumb items={[{ label: promotion.name, to: `/quest_editor/promotion/${promotion.id}` }, { label: quest.name }]} />
        <Stack direction="row" spacing={1} alignItems="center">
          <PromotionTypeChip type={promotion.type} />
          <PromotionStatusChip status={promotion.status} />
        </Stack>
      </Stack>

      <OrderInfoSection
        quest={quest}
        promotion={promotion}
        getTypeLabel={getTypeLabel}
        buildOptionsDisplay={buildOptionsDisplay}
      />

      <PlaceholderSection />

      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{ position: "relative" }}
      >
        <BackButton
          component={Link}
          to={`/quest_editor/promotion/${promotion.id}`}
          sx={{ position: "absolute", left: 0 }}
        >
          {t("order_review.button.back")}
        </BackButton>
        <Stack direction="row" spacing={2}>
          <ActionButton>
            {t("order_review.button.approve")}
          </ActionButton>
          <DangerButton>
            {t("order_review.button.reject")}
          </DangerButton>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default QuestOrderReview;
